import { useNavigate } from "react-router-dom";
import { isApp, appSetMove } from 'utils/AppUtil';
import { getBookpalLink } from 'utils/BookpalLinkUtil';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';

import SubNav from "component/common/nav/SubNav";

import style from '../style/User.module.scss';

function CertNotCouponComplete(){

    const navigate = useBookpalNavigate();

    const handlerMoveMain = ()=>{
        if(isApp()){
            appSetMove("",getBookpalLink("main"));
            return;
        }
        navigate("/");
    }

    return (
        <>
            <SubNav 
                name="본인인증 완료" 
                usePc={false} 
                useMobile={true} 
                setTop={'0px'} 
                useBtnPrev={false} 
                useBtnClose={true}
            />
            
            <div id="container" className={"s_wrap wrapper " + style['container']}>
                <section className={"success " + style['success']}>
                    <p className={"title color-txt-normal title-04 " + style['title'] }>본인인증 완료</p>
                    <div className={"area_box color-bg-01 radius-lg color-border-01 border-soild border-line " + style['area_box']}>
                        <div className={"logo_title " + style['logo_title']}>
                            <p className={"logo " + style['logo']}></p>
                            <p className={"body-01 color-txt-muted label_txt " + style['label_txt']}>당신의 상상이 이야기가 되는 곳</p>
                        </div>
                        <div className={"text_box " + style['text_box']}>
                            <p className={"body-03-long color-txt-normal"}>본인인증이 성공적으로<br />완료되었습니다.</p>
                            {/* <p className={"body-03-long color-txt-normal"}>중복 가입 인증정보가 존재하여<br />선물권이 지급되지 않습니다.</p> */}
                            <p className={"button_box " + style['button_box']}>
                                <button 
                                    type="button" 
                                    className={"radius-sm btn-04 txt btn_01 large label_on filled button " + style['button']}
                                    onClick={handlerMoveMain}
                                >메인으로 이동</button> 
                            </p>
                        </div>
                    </div>        
                </section>
            </div>
        </>
    );
}



export default CertNotCouponComplete;